"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _stateMaintainer = _interopRequireDefault(require("../stateMaintainer"));

var _browserRefreshing = _interopRequireDefault(require("./browserRefreshing"));

var _finiteStateMachine = _interopRequireDefault(require("./finiteStateMachine"));

var _web3Factory = _interopRequireDefault(require("./web3Factory"));

var _error = _interopRequireDefault(require("../core/error"));

var _selectWallet = _interopRequireDefault(require("./skin/selectWallet"));

var _inputAsset = _interopRequireDefault(require("./skin/inputAsset"));

var _establishConnection = _interopRequireDefault(require("./skin/establishConnection"));

var _connectDevice = _interopRequireDefault(require("./skin/connectDevice"));

var _confirmAddress = _interopRequireDefault(require("./skin/confirmAddress"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Constants
const ERROR = 'Wallet was broken';
const DEFAULT_STATE = {
  visible: false,
  step: 'Idle',
  error: ''
};
const DEFAULT_OPT = {
  networkId: 1,
  pageRefreshing: true
};

class Ethereum extends _react.Component {
  /**
   * @props net - Network id
   * @props visible - Boolean
   * @props done - Callback function
   */
  constructor(props) {
    super(props);

    _defineProperty(this, "onData", (er, re) => {
      // User meets error in processing
      if (er) return this.onError(er); // Heros are working :)
      // Move to next step

      const state = this.FSM.next(re); // Run to next step
      // Error case

      if (state.step === 'Error') return this.onError(ERROR); // Success case

      if (state.step === 'Success') return this.onClose(() => {
        // Store state
        if (this.options.pageRefreshing && _browserRefreshing.default.isSupported(state.model)) this.SM.setState(state);
        this.W3F.generate(state, (er, provider) => {
          if (er) return this.onError(er);
          window.kambriaWallet.provider = provider;
          return this.done(null, provider);
        });
      }); // Still in processing

      return this.setState({
        step: state.step
      });
    });

    _defineProperty(this, "onError", er => {
      return this.setState({
        visible: true,
        error: er,
        step: 'Error'
      }, () => {
        return this.FSM.reset();
      });
    });

    _defineProperty(this, "onClose", callback => {
      return this.setState({
        visible: true
      }, () => {
        return this.setState({
          visible: false
        }, () => {
          this.setState(_objectSpread({}, DEFAULT_STATE), () => {
            return this.FSM.reset();
          });
          if (callback) callback();
        });
      });
    });

    this.done = props.done;
    this.options = _objectSpread(_objectSpread({}, DEFAULT_OPT), props.options);
    this.SM = new _stateMaintainer.default();
    this.FSM = new _finiteStateMachine.default();
    this.W3F = new _web3Factory.default();
    this.state = _objectSpread(_objectSpread({}, DEFAULT_STATE), {}, {
      step: props.visible ? this.FSM.next().step : 'Idle'
    });
  }

  componentDidMount() {
    if (!this.options.pageRefreshing) return; // Regenerate state

    this.SM.isStateMaintained(state => {
      if (state) return this.W3F.regenerate(state, (er, provider) => {
        if (er) return window.kambriaWallet.logout();
        window.kambriaWallet.provider = provider;
        return this.done(null, provider);
      });
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible) {
      if (this.props.visible) {
        window.kambriaWallet.back = () => {
          let state = this.FSM.back();
          if (state.step === 'Idle') return window.kambriaWallet.home();
          return this.setState({
            step: state.step
          });
        };

        this.setState({
          visible: true,
          step: this.FSM.next().step
        });
      } else {
        window.kambriaWallet.back = null;
        this.setState(_objectSpread({}, DEFAULT_STATE));
      }
    }
  }
  /**
   * Flow management
   */


  render() {
    const _this$state = this.state,
          step = _this$state.step,
          error = _this$state.error;
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, step === 'SelectWallet' ? /*#__PURE__*/_react.default.createElement(_selectWallet.default, {
      data: this.FSM.data,
      done: this.onData,
      onClose: () => this.onClose(this.done)
    }) : null, step === 'InputAsset' ? /*#__PURE__*/_react.default.createElement(_inputAsset.default, {
      data: this.FSM.data,
      done: this.onData,
      onClose: () => this.onClose(this.done)
    }) : null, step === 'EstablishConnection' ? /*#__PURE__*/_react.default.createElement(_establishConnection.default, {
      data: this.FSM.data,
      done: this.onData,
      onClose: () => this.onClose(this.done)
    }) : null, step === 'ConnectDevice' ? /*#__PURE__*/_react.default.createElement(_connectDevice.default, {
      data: this.FSM.data,
      done: this.onData,
      onClose: () => this.onClose(this.done)
    }) : null, step === 'ConfirmAddress' ? /*#__PURE__*/_react.default.createElement(_confirmAddress.default, {
      data: this.FSM.data,
      done: this.onData,
      onClose: () => this.onClose(this.done)
    }) : null, step === 'Error' ? /*#__PURE__*/_react.default.createElement(_error.default, {
      error: error,
      done: () => this.onClose(() => this.done(error, null))
    }) : null);
  }

}

var _default = Ethereum;
exports.default = _default;